import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.baoubab.space';

export const fetchRandomPopup = createAsyncThunk(
  'popup/fetchRandom',
  async (isAuthenticated, { rejectWithValue }) => {
    const targetAudience = isAuthenticated ? 'logged_in' : 'logged_out';

    try {
      const response = await axios.get(
        `${API_URL}/api/public/popup-ads/random`,
        {
          params: { target_audience: targetAudience },
          validateStatus: (status) => status === 200 || status === 204,
        }
      );

      if (response.status === 204 || !response.data?.id) {
        return null;
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Impossible de charger le popup'
      );
    }
  }
);

export const recordPopupClick = createAsyncThunk(
  'popup/recordClick',
  async (popupId, { rejectWithValue }) => {
    try {
      await axios.post(`${API_URL}/api/public/popup-ads/${popupId}/click`);
      return popupId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Erreur clic popup');
    }
  }
);

const popupSlice = createSlice({
  name: 'popup',
  initialState: {
    currentPopup: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearPopup: (state) => {
      state.currentPopup = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRandomPopup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRandomPopup.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPopup = action.payload;
      })
      .addCase(fetchRandomPopup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.currentPopup = null;
      });
  },
});

export const { clearPopup } = popupSlice.actions;
export default popupSlice.reducer;
